import React from 'react';

import { ReactComponent as DuploLogoWhite } from '../../public/assets/duplo-logo-white.svg';
import { ReactComponent as DuploLogoBlack } from '../../public/assets/duplo-logo.svg';

import Search from './Search';

const NavBar = ({
  isFeatured,
  projects,
  isSearching,
  setIsSearching,
  setSearchedProjects,
}: {
  isFeatured: boolean;
  projects: Project[];
  isSearching: boolean;
  setIsSearching: SetIsSearching;
  setSearchedProjects: SetSearchedProjects;
}) => {
  if (isFeatured) {
    return (
      <div className="navbar-featured">
        <DuploLogoWhite
          className="navbar-logo navbar-logo-featured"
          alt="DuploCloud Logo"
        />
      </div>
    );
  }
  return (
    <div className="navbar">
      <DuploLogoBlack className="navbar-logo" alt="DuploCloud Logo" />
      <div className="navbar-search">
        <Search
          projects={projects}
          isSearching={isSearching}
          setIsSearching={setIsSearching}
          setSearchedProjects={setSearchedProjects}
        />
      </div>
    </div>
  );
};

export default NavBar;
